export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_23eb42e2-b157-4229-aaf6-305642aa36e3/artifacts/0d5ktwis_logo%20en%20color.jpg";

export const PHONE = "+34 622 46 36 74";
export const PHONE_RAW = "34622463674";
export const WHATSAPP_URL = `https://wa.me/${PHONE_RAW}?text=${encodeURIComponent(
    "Hola, quiero reservar mi valoración gratuita con F You Gestión Deportiva.",
)}`;

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1605296867424-35fc25c9212a?auto=format&fit=crop&w=1920&q=85",
    heroBg:
        "https://static.prod-images.emergentagent.com/jobs/23eb42e2-b157-4229-aaf6-305642aa36e3/images/c499e1eb293794b7a4a2aef9b6b64f351f99e2b63f2a88815c3b94c18a34a612.png",
    mapBg:
        "https://static.prod-images.emergentagent.com/jobs/23eb42e2-b157-4229-aaf6-305642aa36e3/images/59183f4c77c05b33866a1275cc649aa444085b7aa4c4f15383f6ead28491d31f.png",
    womanLift1:
        "https://images.unsplash.com/photo-1533681904393-9ab6eee7e408?auto=format&fit=crop&w=1400&q=85",
    womanLift2:
        "https://images.unsplash.com/photo-1591258370814-01609b341790?auto=format&fit=crop&w=1400&q=85",
    womanRope:
        "https://images.unsplash.com/photo-1599058917765-a780eda07a3e?auto=format&fit=crop&w=1400&q=85",
    womanGlutes:
        "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1400&q=85",
    manDeadlift:
        "https://images.unsplash.com/photo-1623874514711-0f321325f318?auto=format&fit=crop&w=1400&q=85",
    manFunctional:
        "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=1400&q=85",
    sweat:
        "https://images.unsplash.com/photo-1532384748853-8f54a8f476e2?auto=format&fit=crop&w=1400&q=85",
    gymDark:
        "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?auto=format&fit=crop&w=1400&q=85",
    dumbbells:
        "https://images.unsplash.com/photo-1574680096145-d05b474e2155?auto=format&fit=crop&w=1400&q=85",
    cardio:
        "https://images.unsplash.com/photo-1538805060514-97d9cc17730c?auto=format&fit=crop&w=1400&q=85",
    coach:
        "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?auto=format&fit=crop&w=1400&q=85",
    transformBefore:
        "https://images.unsplash.com/photo-1594381898411-846e7d193883?auto=format&fit=crop&w=900&q=85",
    transformAfter:
        "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=900&q=85",
};

export const CENTROS = [
    {
        id: "parla",
        nombre: "Parla",
        direccion: "Basic-Fit Parla — C. María Zambrano, 18",
        cp: "28981 Parla, Madrid",
        coords: { top: "68%", left: "44%" },
        highlights: [
            "Instalaciones limpias y modernas",
            "Equipos premium en perfecto estado",
            "Ambiente motivador 24/7",
        ],
        image:
            "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?auto=format&fit=crop&w=1200&q=85",
        maps: "https://maps.google.com/?q=Basic-Fit+Parla+C.+Mar%C3%ADa+Zambrano+18",
    },
    {
        id: "getafe",
        nombre: "Getafe",
        direccion: "Basic-Fit Getafe — CC Getafe 3, Av. Juan Carlos I, 1",
        cp: "28905 Getafe, Madrid",
        coords: { top: "62%", left: "46%" },
        highlights: [
            "Entrenadores profesionales certificados",
            "Clases colectivas de alta intensidad",
            "Atención 100% personalizada",
        ],
        image:
            "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?auto=format&fit=crop&w=1200&q=85",
        maps: "https://maps.google.com/?q=Basic-Fit+Getafe+CC+Getafe+3",
    },
    {
        id: "fuenlabrada",
        nombre: "Fuenlabrada",
        direccion: "Basic-Fit Fuenlabrada — C. de Brasil, 2",
        cp: "28946 Fuenlabrada, Madrid",
        coords: { top: "65%", left: "41%" },
        highlights: [
            "Monitores cercanos y exigentes",
            "Entrenamientos intensos de élite",
            "Ambiente fitness moderno",
        ],
        image:
            "https://images.unsplash.com/photo-1574680096145-d05b474e2155?auto=format&fit=crop&w=1200&q=85",
        maps: "https://maps.google.com/?q=Basic-Fit+Fuenlabrada+C.+de+Brasil+2",
    },
];
